import styled from 'styled-components';

import { BaseCard } from './BaseCard';

import { colors, breakpoints } from '../../constants';

interface IProps {
    cardColor: string;
    dragged: boolean;
    style?: React.CSSProperties;
}

export const CardInner = styled(BaseCard)<IProps>`
    background-color: ${(props) =>
        props.cardColor ? props.cardColor : colors.greenBg};
    flex: 1 1 auto;

    @media (${breakpoints.mediumMin}) {
        padding: 50px;
        background-color: unset;
    }
`;
